import Reference from '@/fhirworks/types/Reference';
import merge from 'lodash/merge';
import DomainResource from './DomainResource';

/**
 * BN_MessageThreadParticipant custom resource — one party's membership in a message thread.
 *
 * Removal is deactivation, never deletion: leaving a thread sets `active` to false and stamps
 * `leftAt`, so the record survives as an audit trail alongside `joinedAt` (the invitation
 * point) and `invitedBy`. `lastReadAt` is the unread watermark — absent means the participant
 * has never read the thread.
 */
export default class BN_MessageThreadParticipant extends DomainResource {
    static __className = 'BN_MessageThreadParticipant';
    __objectStructure = {
        thread: Reference,
        participant: Reference,
        active: Boolean,
        joinedAt: String,
        invitedBy: Reference,
        leftAt: String,
        lastReadAt: String,
    };

    __objectDefaults = {
        active: true,
    };

    constructor(constructJson, className = 'BN_MessageThreadParticipant') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
